import { useState } from 'react';
import { useStartMutation } from '../../__generated__/chirp/com/hubspot/dpg/devex/agents/rpc/WorkspacesRpc.hooks';
import { navigateToWorkspace } from '../utils/urls';
export function useAppBuilderPromptSubmission({
  disabled,
  initialPrompt,
  onChange,
  onError,
  onSubmit,
  onWorkspaceCreated,
  value
}) {
  const [internalPrompt, setInternalPrompt] = useState(initialPrompt !== null && initialPrompt !== void 0 ? initialPrompt : '');
  const [startWorkspace, {
    loading: isSubmitting
  }] = useStartMutation();
  const promptValue = value !== null && value !== void 0 ? value : internalPrompt;
  const isSubmitDisabled = isSubmitting || !!disabled || !promptValue.trim();
  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    onSubmit === null || onSubmit === void 0 || onSubmit(promptValue);
    startWorkspace({
      variables: {
        initialPrompt: promptValue
      }
    }).then(result => {
      var _result$data;
      const workspaceId = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.result.id;
      if (workspaceId != null) {
        onWorkspaceCreated === null || onWorkspaceCreated === void 0 || onWorkspaceCreated(workspaceId, promptValue);
        navigateToWorkspace(workspaceId, {
          pending: 'true'
        });
      } else {
        onError === null || onError === void 0 || onError();
      }
    }).catch(e => onError === null || onError === void 0 ? void 0 : onError(e));
  };
  const handleChange = next => {
    setInternalPrompt(next);
    onChange === null || onChange === void 0 || onChange(next);
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };
  return {
    promptValue,
    isSubmitting,
    isSubmitDisabled,
    handleChange,
    handleKeyDown,
    handleSubmit
  };
}